import moment from "moment"

// "Uploaded" time of a content record: when it was uploaded, NOT the date of the file itself (a
// file picked from disk can be days or years old; the browser only knows when it was last modified).
//
// That moment is hidden in the record id: a Firebase push id starts with the time it was created
// at, which is the start of the upload. It holds for every record, old and new, so it is what is
// shown and sorted by. `timestamp` is only the fallback for an id that is not a push id. New uploads
// store the upload time there; older records may hold the date of their FILE there (that is what
// showed wrong times), or another format (milliseconds, an ISO string with an offset).

const PUSH_CHARS = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz"
const MIN_PUSH_TIME = Date.UTC(2015, 0, 1)
const DAY_MS = 24 * 60 * 60 * 1000

// Milliseconds since 1970 hidden in a push id, or null when `id` is not a plausible push id
export const pushIdTime = (id, now = Date.now()) => {
  if (typeof id !== "string" || id.length !== 20) return null
  let time = 0
  for (const char of id.slice(0, 8)) {
    const index = PUSH_CHARS.indexOf(char)
    if (index < 0) return null
    time = time * 64 + index
  }
  return time >= MIN_PUSH_TIME && time <= now + DAY_MS ? time : null
}

// Milliseconds since 1970 for a stored time (ISO string, or a number in ms or in seconds),
// or null when it is missing or cannot be read
export const toTime = (value) => {
  if (value === undefined || value === null || value === "") return null
  let time
  if (typeof value === "number") {
    time = value < 1e11 ? value * 1000 : value
  } else {
    time = moment(String(value), moment.ISO_8601).valueOf()
  }
  return Number.isFinite(time) && time > 0 ? time : null
}

export const contentTime = (item, now = Date.now()) => pushIdTime(item?.id, now) ?? toTime(item?.timestamp)

// Local, readable, e.g. "October 8, 2026 9:46 AM"; empty when unknown
export const formatContentTime = (item, now) => {
  const time = contentTime(item, now)
  return time === null ? "" : moment(time).format("LLL")
}
